import { Alert, Platform } from "react-native";

const isWeb = Platform.OS === "web";

type ConfirmOptions = {
  destructive?: boolean;
  cancelLabel?: string;
  confirmLabel?: string;
};

export const Attention = {
  alert(title: string, message: string) {
    if (isWeb) {
      alert(message);
    } else {
      Alert.alert(title, message);
    }
  },

  confirm(title: string, message: string, options?: ConfirmOptions) {
    return new Promise<boolean>((resolve) => {
      if (isWeb) {
        resolve(confirm(message));
      } else {
        Alert.alert(title, message, [
          {
            text: options?.cancelLabel || "Cancel",
            onPress: () => resolve(false),
            style: "cancel",
          },
          {
            text: options?.confirmLabel || "OK",
            onPress: () => resolve(true),
            style: options?.destructive ? "destructive" : "default",
          },
        ]);
      }
    });
  },
};
